export default {
    "Success": true,
    "htmlMessage": null,
    "Data": [
        {
            "brandUrl": "https://payoneer--mis.zendesk.com",
            "brandName": "Apps & Integrations",
            "projects": [
                {
                    "id": "26f6a4bc-1d17-44c6-b319-f1425e2a8f19",
                    "name": "Apps and Integrations"
                }
            ]
        },
        {
            "brandUrl": "https://payoneer-data-analytics.zendesk.com",
            "brandName": "Data & Analytics",
            "projects": [
                {
                    "id": "e71fc372-170e-4bcb-b13b-d803756b3e4f",
                    "name": "Data"
                }
            ]
        }
        
        //test cases
        ,{
            "brandUrl": "https://help.devopsintegration.io",
            "brandName": "DevOps Integration",
            "projects": [
                {
                    "id": "26f6a4bc-1d17-44c6-b319-f1425e2a8f19",
                    "name": "Apps and Integrations"
                }
            ]
        },
        {
            "brandUrl": "https://devops-test.zendesk.com",
            "brandName": "Test Brand",
            "projects": [
                {
                    "id": "e71fc372-170e-4bcb-b13b-d803756b3e4f",
                    "name": "Data"
                }
            ]
        },
    ]
}